import React from 'react';
import { Navigate, useLocation, matchPath } from 'react-router-dom';

interface IProps {
  from: string;
  to: string;
}

export default ({ from, to }: IProps) => {
  const location = useLocation();

  const redirectPathMatched = matchPath(from, location.pathname);

  if (redirectPathMatched) {
    const { pathname, pathnameBase } = redirectPathMatched;

    const newPathname = pathname.replace(pathnameBase, to);

    return (
      <Navigate
        replace={true}
        to={{
          pathname: newPathname,
          search: location.search,
          hash: location.hash,
        }}
      />
    );
  }

  return null;
};
